export default {
  loadProductTableSuccess: (state, payload) => {
    state.productTable.items = payload.data;
    state.productTable.filteredRecords = payload.recordsFiltered;
  },
  setProductTablePagination({ productTable }, payload) {
    productTable.pagination.descending = payload.descending;
    productTable.pagination.page = payload.page;
    productTable.pagination.rowsPerPage = payload.rowsPerPage;
    productTable.pagination.sortBy = payload.sortBy;
    productTable.pagination.totalItems = payload.totalItems;
    productTable.pagination.search = payload.search;
  },
  setPagination({ state }, payload) {
    state.productTable.pagination = payload;
  },
  setGeneratedQAs: (state, payload) => {
    state.generatedQAs = payload.data;
  },
  setAskedQAs: (state, payload) => {
    state.askedQAs = payload.data;
  },
};
